<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 106 6 6 6 0 00-6-6zm2.35 7.65a.48.48 0 010 .7.48.48 0 01-.7 0L8 8.71l-1.65 1.64a.48.48 0 01-.7 0 .48.48 0 010-.7L7.29 8 5.65 6.35a.49.49 0 01.7-.7L8 7.29l1.65-1.64a.49.49 0 01.7.7L8.71 8z"/></svg>